<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="1" class="form-group" style="min-width: 105px; max-width: 120px;">
        <label>Thao tác</label>
        <div class="dropdown btn-group" style="height: 36px;">
          <button class="btn">
            <div class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.selectedAll"
                  @change="changeSelectAll"
                  id="selectedAll"
                />
                <label class="custom-control-label" for="selectedAll"></label>
              </div>
            </div>
          </button>
          <button
            type="button"
            class="dropdown-toggle dropdown-toggle-split btn"
            data-toggle="dropdown"
            aria-expanded="false"
            aria-haspopup="true"
          ></button>
          <div class="dropdown-menu">
            <button
              :disabled="actionData.model.listStationSelectedId.length === 0"
              class="dropdown-item"
              @click="setupSelectOneAction('delete_list')"
              color="danger"
            >
              <CIcon name="cil-trash" style="danger" class="mr-2"/>
              Xóa tất cả
            </button>
          </div>
        </div>
      </CCol>
      <CCol sm="3" md="3" xs="12" xl="2">
        <BaseInput
          :options="valueStationInput.options"
          :data="valueStationInput.data"
          :listener="valueStationInput.listener"
        />
      </CCol>
      <CCol sm="3" md="3" xs="12" xl="2">
        <BaseInput
          :options="nameStationInput.options"
          :data="nameStationInput.data"
          :listener="nameStationInput.listener"
        />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp; Tải lại
            </CButton>
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Thêm mới'"
              class="btn-action-primary"
              @click="$router.push('/audio-station-management/audio-station-new.html')">
              <i class="fa fa-plus"></i>&nbsp; Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #checkbox="{item}">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.listStationSelectedId"
                  :value="item.id"
                  :id="item.id"
                  v-c-tooltip.hover="'Selected'"
                />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </template>
          <template #index="{index}">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #action="{item}">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton v-if="$hasAuthor('ROLE_ADMIN')"
                         color="warning"
                         variant="outline"
                         class="ml-1"
                         square
                         size="sm"
                         v-c-tooltip.hover="'Cấu hình'"
                         @click="setupConfigAPI(item)">
                  <CIcon name="cil-settings"/>
                </CButton>
                <CButton
                  color="info"
                  variant="outline"
                  class="ml-1"
                  square
                  size="sm"
                  v-c-tooltip.hover="'Cập nhật'"
                  @click="$router.push(`${item.id}/audio-station-update.html`)">
                  <CIcon name="cil-pencil"/>
                </CButton>
                <CButton
                  color="danger"
                  variant="outline"
                  class="ml-1"
                  square
                  size="sm"
                  v-c-tooltip.hover="'Xóa'"
                  @click="setupSelectOneAction('delete_one', item.id, item.name)">
                  <CIcon name="cil-trash"/>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>
    <CModal title="Cấu hình API" :show.sync="isShowPopupConfigAPI" :closeOnBackdrop="true">
      <CRow class="content-fade-in">
        <CCol md="12">
          <CForm class="form-basic">
            <CRow>
              <CCol sm="12" md="12" xs="12" xl="12">
                <BaseSelect :options="configAPI.contractorInformation.options"
                            :data="configAPI.contractorInformation.data"
                            ref="contractorInformation"></BaseSelect>
              </CCol>
            </CRow>
          </CForm>
        </CCol>

      </CRow>
      <div slot="footer">
        <CButton color="primary" class="btn-action-primary" @click="submitConfigAPI()"
                 :disabled="loadingConfigAPI.value"><i
          class="fa fa-check"></i> Đồng ý
        </CButton>
        &nbsp;
        <CButton color="secondary" class="btn-action-primary" @click="isShowPopupConfigAPI = false"
                 :disabled="loadingConfigAPI.value"><i
          class="fa fa-times"></i> Đóng
        </CButton>
      </div>

      <BaseFormLoading :loading="loadingConfigAPI.value"></BaseFormLoading>
    </CModal>

    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "../../base/BaseDataTable";
import ModalConfirm from "../../base/BaseModalConfirm";
import BaseInput from "../../base/BaseInput";
import BaseSelect from "../../base/BaseSelect2"
import BaseFormLoading from "@/views/base/BaseFormLoading";

export default {
  name: "AudioStationFileList",
  components: {
    BaseFormLoading,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();
    actionTypeMapping.set("delete_one", {
      url: "/audio-station/delete",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "nhóm truyền thanh",
          that.actionData.model.audioStationName
        );
      },
      isJsonContentType: true,
      dataSubmit: function () {
        return {id: that.actionData.model.audioStationId};
      },
      successCallback: function () {
        that.actionData.model.listStationSelectedId = [];
        that.showSuccessMsg({message: "Xóa nhóm truyền thanh thành công"});
        that.loadDataMainTable();
      }
    });
    actionTypeMapping.set("delete_list", {
      url: "/audio-station/delete-list",
      titlePopup: function () {
        return that.$helper.setupTitleAction("Xóa", "các nhóm truyền thanh", "đã chọn");
      },
      isJsonContentType: true,
      dataSubmit: function () {
        return {
          lsId: that.actionData.model.listStationSelectedId
        };
      },
      successCallback: function () {
        that.actionData.model.listSaudioStationId = [];
        that.showSuccessMsg({message: "Xóa danh sách nhóm truyền thanh thành công"});
        that.loadDataMainTable();
      },
    });

    return {
      loading: {value: false},
      loadingConfigAPI: {value: false},
      isShowPopupConfigAPI: false,
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          audioStationId: null,
          audioStationName: null,
          listStationSelectedId: []
        }
      },
      valueStationInput: {
        options: {
          placeholder: "Mã nhóm truyền thanh",
          label: 'Mã nhóm truyền thanh'
        },
        data: {
          name: "value",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      nameStationInput: {
        options: {
          placeholder: "Tên nhóm truyền thanh",
          label: 'Tên nhóm truyền thanh'
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      mainTable: {
        options: {
          fields: [
            {key: "checkbox", label: "#", sorter: false, filter: false},
            {key: "value", label: "Mã nhóm truyền thanh"},
            {key: "name", label: "Tên nhóm truyền thanh"},
            {key: "description", label: "Mô tả"},
            {key: "action", label: "Thao tác", sorter: false, filter: false}
          ],
          slots: ["checkbox", "index", "action"],
          columnFilter: false,
          tableFilter: false,
          sorter: true
        },
        dataSource: {
          url: "/audio-station/getPages",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      },
      configAPI: {
        idInput: {
          data: {
            name: "id",
            model: ""
          }
        },
        contractorInformation: {
          options: {
            filter: true,
            label: "Cấu hình truyền thanh cơ sở",
            selectAllText: "Chọn cấu hình truyền thanh cơ sở",
            'keyField': 'value',
            'valueField': 'text',
          },
          data: {
            name: "contractorInformation",
            model: null,
            items: [],
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.configAPI.contractorInformation.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Cấu hình truyền thanh cơ sở không được để trống";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              },
            },
          }
        },
      }
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    changeSelectAll: function () {
      if (this.actionData.model.selectedAll) {
        this.actionData.model.listStationSelectedId = [];
        this.$refs.mainTable.items.forEach(each => {
          this.actionData.model.listStationSelectedId.push(each.id);
        });
      } else {
        this.actionData.model.listStationSelectedId = [];
      }
    },
    setupSelectOneAction: function (actionTypeKey, audioStationId, audioStationName) {
      var actionData = this.actionData.model;
      actionData.audioStationId = audioStationId || null;
      actionData.audioStationName = audioStationName || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    setupSelectMoreAction: function (actionTypeKey) {
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    setupConfigAPI(item) {
      this.configAPI.idInput.data.model = item.id;
      this.configAPI.contractorInformation.data.items = [];
      this.configAPI.contractorInformation.data.validator.isValid = true;
      this.configAPI.contractorInformation.data.validator.errorMessage = "";
      this.loadDataContractorInformation(item);
    },
    async loadDataContractorInformation(item) {
      let that = this;
      that.loading.value = true;
      await this.$helper.loadDataSource({
        loading: that.loading,
        isJsonContentType: false,
        dataSubmit: function () {
          return {typeSystem: 0};
        },
        url: "/contract_information/getListForSelectOption",
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            let {data} = response.data;
            data.forEach(each => {
              that.configAPI.contractorInformation.data.items.push(each);
            })
            that.isShowPopupConfigAPI = true;
            setTimeout(() => {
              if (item.contractorInformation) {
                that.configAPI.contractorInformation.data.model = item.contractorInformation;
              }
            });
          }
          that.loading.value = false;
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false;
        },
      });
    },
    submitConfigAPI: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loadingConfigAPI,
        url: "/audio-station/config_api",
        dataRef: function () {
          return that.$data.configAPI;
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data),});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({message: "Cấu hình API nhóm truyền thanh thành công",});
            that.loadDataMainTable();
            that.isShowPopupConfigAPI = false;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    "actionData.model.listStationSelectedId": function (newValue) {
      var that = this;
      if (newValue.length === that.$refs.mainTable.items.length) {
        that.actionData.model.selectedAll = true;
      } else {
        that.actionData.model.selectedAll = false;
      }
    },
  },
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
